import { Stack } from "@mui/material";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import MonthPicker from "../components/monthPicker/MonthPicker";

export interface IncomingTransfersSearchCriteria {
  readonly startDate: Dayjs;
}

interface Props {
  readonly search: IncomingTransfersSearchCriteria;
  readonly onChange: (value: IncomingTransfersSearchCriteria) => void;
}

const IncomingTransfersSearch: FC<Props> = ({ search, onChange }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        paddingX: 2,
      }}
    >
      <MonthPicker value={search.startDate} onChange={(date) => date && onChange({ startDate: date })} />
    </Stack>
  );
};

export default IncomingTransfersSearch;
